import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type {
  SignerLookupRequest,
  SignerLookupResponse,
} from '../types/brebSignerLookup.type';

export const brebSignerLookupService = {
  /**
   * Valida la llave Bre-B de un destinatario contra el directorio de firmantes.
   * @param payload - Alias (teléfono, correo, documento o @usuario) a validar.
   * @returns Promesa que resuelve a `Right<SignerLookupResponse>` cuando la llave
   * puede recibir, o `Left<ApiFailure>` en caso contrario. Los reasons que
   * distinguen el estado de la llave están en `ErrorsBrebSignerLookup`.
   */
  getSignerLookup(
    payload: SignerLookupRequest
  ): Promise<ApiResult<SignerLookupResponse>> {
    return executeRequest(() =>
      http.post<SignerLookupResponse>('breb/b2b/signers/lookup', payload)
    );
  },
};
